import React from 'react'
import {
	Box,
} from "@mui/material"
import { getAllUrlParams } from '@helpers/index';
import { media9codeOrCms } from '@utils/common';
import MediaLibrary from "@components/common/MediaLibrary";

const BrowseImage = () => {
	function getUrlParam(paramName: string) {
		const reParam = new RegExp('(?:[?&]|&)' + paramName + '=([^&]+)', 'i');
		const match = window.location.search.match(reParam);

		return (match && match.length > 1) ? match[1] : null;
	}

	function returnFileUrl(imageSrc: any) {
		const funcNum = getUrlParam('CKEditorFuncNum');		
		
		// Nếu có funcNum thì dùng cách mặc định của CKEditor (qua dialog)
		if (funcNum && window.opener && window.opener.CKEDITOR) {
			window.opener.CKEDITOR.tools.callFunction(funcNum, imageSrc);
		} 
		// Nếu không có funcNum và có hàm callback trực tiếp thì chèn thẳng vào editor
		else if (window.opener && window.opener.ckEditorInsertImage) {
			window.opener.ckEditorInsertImage(imageSrc);
		}
		
		window.close();
	}

	const handleSelectImage = (imageIdOrPath: string) => {
		// MediaLibrary returns either ID or full path based on returnFullPath prop
		// We want the full URL for CKEditor
		returnFileUrl(media9codeOrCms(imageIdOrPath));
	}

	return (
		<Box sx={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
			<MediaLibrary
				open={true}
				onClose={() => window.close()}
				businessId="qrcodeadmin"
				onSelectImage={handleSelectImage}
				returnFullPath={false}
			/>
		</Box>
	)
}

export default BrowseImage
